/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * KoboToolbox Primary API
 * This page documents all KoboToolbox API endpoints, except for those implementing the OpenRosa protocol, which are [documented separately](/api/openrosa/docs/).

The endpoints are grouped by area of intended use. Each category contains related endpoints, with detailed documentation on usage and configuration. Use this as a reference to quickly find the right endpoint for managing projects, forms, data, permissions, integrations, logs, and organizational resources.

**General note**: All projects (whether deployed or draft), as well as all library content (questions, blocks, templates, and collections) in the user-facing application are represented in the API as "assets".
 * OpenAPI spec version: 2.0.0 (api_v2)
 */

/**
 * * `admin` - admin
 * `member` - member
 * `owner` - owner
 */
export type MemberRoleEnum = (typeof MemberRoleEnum)[keyof typeof MemberRoleEnum]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberRoleEnum = {
  admin: 'admin',
  member: 'member',
  owner: 'owner',
} as const
